<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        互联网平台及产品信息
        <div
          style="
            flex: 1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <!--内容开始-->
      <div class="productInfor">
        <div
          style="
            width: calc(100% - 40px);
            padding: 25px 20px;
            background-color: rgb(248, 248, 248);
            margin-bottom: 20px;
            font-size: 14px;
            line-height: 25px;
            text-indent: 2em;
          "
        >
          查询下列自营网络平台的名称、网址，请您登陆中国保险行业协会官方网站（链接网址：
          <a
            href="http://icid.iachina.cn/?columnid_url=201509301401"
            target="_blank"
          >
            http://icid.iachina.cn/?columnid_url=201509301401
          </a>
          ）在“信息披露”子菜单“互联网保险信息披露”中输入“中智保险经纪”关键字搜索查阅。
        </div>
        <div>
          <p>1、经营互联网保险业务的移动端</p>
          <div class="tableList">
            <div
              class="
                el-table
                el-table--fit
                el-table--border
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
            >
              <div class="hidden-columns">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="el-table__header-wrapper">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__header"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_37_column_141" width="80" />
                    <col name="el-table_37_column_146" width="457" />
                    <col name="el-table_37_column_147" width="457" />
                    <col name="gutter" width="0" />
                  </colgroup>
                  <thead class="has-gutter">
                    <tr class="">
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_37_column_141 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">序号</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_37_column_146 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">平台名称</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_37_column_147 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">平台载体</div>
                      </th>
                      <th class="gutter" style="width: 0px; display: none"></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="el-table__body-wrapper is-scrolling-none">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__body"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_37_column_141" width="80" />
                    <col name="el-table_37_column_146" width="457" />
                    <col name="el-table_37_column_147" width="457" />
                  </colgroup>
                  <tbody>
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_37_column_141 is-center"
                      >
                        <div class="cell">1</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_37_column_146 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>中智安心服务</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_37_column_147 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>微信公众号</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>

                    <!---->
                  </tbody>
                </table>
                <!----><!---->
              </div>
              <!----><!----><!----><!---->
              <div
                class="el-table__column-resize-proxy"
                style="display: none"
              ></div>
            </div>
          </div>
        </div>
        <div>
          <p>2、互联网保险产品</p>
          <div class="tableList">
            <div
              class="
                el-table
                el-table--fit
                el-table--border
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
            >
              <div class="hidden-columns">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="el-table__header-wrapper">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__header"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_38_column_142" width="80" />
                    <col name="el-table_38_column_148" width="186" />
                    <col name="el-table_38_column_149" width="182" />
                    <col name="el-table_38_column_150" width="360" />
                    <col name="el-table_38_column_151" width="182" />
                    <col name="el-table_38_column_152" width="182" />
                    <col name="gutter" width="0" />
                  </colgroup>
                  <thead class="has-gutter">
                    <tr class="">
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_142 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">序号</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_148 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">销售产品名称</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_149 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">备案产品名称</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_150 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">备案编号/批复文号</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_151 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">承保机构</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_38_column_152 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">合作日期</div>
                      </th>
                      <th class="gutter" style="width: 0px; display: none"></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="el-table__body-wrapper is-scrolling-none">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__body"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_38_column_142" width="80" />
                    <col name="el-table_38_column_148" width="186" />
                    <col name="el-table_38_column_149" width="182" />
                    <col name="el-table_38_column_150" width="360" />
                    <col name="el-table_38_column_151" width="182" />
                    <col name="el-table_38_column_152" width="182" />
                    <col name="gutter" width="0" />
                  </colgroup>
                    <tbody>
                        
						
						
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">1</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>众无忧·众安家庭意外险</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>附加保险事故限制特约保险（互联网2022版）</span>
								<span>家庭成员意外伤害保险（互联网2022版A款）</span>
								<span>家庭成员营运交通工具乘客意外伤害保险（互联网2022版A款）</span>
								<span>附加家庭成员意外伤害医疗费用保险（互联网2022版B款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017931922022062915531,(众安在线)(备-其他)【2023】(附) 093号<br/>
							C00017932312021122833323,(众安在线)(备-普通意外保险)【2021】(主) 173号<br/>
							C00017932312021122833433,(众安在线)(备-普通意外保险)【2021】(主) 175号<br/>
							C00017932522022122800251
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">2</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>孝欣保中老年人综合意外（3号）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>驾乘人员意外伤害保险（互联网）</span>
								<span>附加意外伤害住院津贴保险（互联网）</span>
								<span>个人意外伤害保险（互联网）</span>
								<span>公共场所意外伤害保险（互联网）</span>
								<span>附加意外伤害救护车费用保险（互联网）</span>
								<span>个人意外伤害骨折保险（互联网2022版B款）</span>
								<span>附加意外伤害医疗费用保险（互联网2024版B款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932312021120203903,(众安在线)(备-普通意外保险)【2021】(主) 142号<br/>
							C00017932522021120404633,(众安在线)(备-医疗保险)【2021】(附) 228号<br/>
							C00017932312021120304873,(众安在线)(备-普通意外保险)【2021】(主) 129号<br/>
							C00017932312021120404673,(众安在线)(备-普通意外保险)【2021】(主) 148号<br/>
							C00017932522021112201573,(众安在线)(备-医疗保险)【2021】(附) 164号<br/>
							C00017932312022021610091,(众安在线)(备-普通意外保险)【2022】(主) 019号<br/>
							C00017932522024012316971

                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">3</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>众民保·重疾险</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人重大疾病保险（互联网普惠款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932612024121900983
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">4</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>众民保·复发险</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人特定恶性肿瘤转移复发疾病保险（互联网2025版）</span>
								<span>附加个人对侧原发性特定恶性肿瘤疾病保险（互联网2025版A款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932612025022008863<br/>
							C00017932622025061126783
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">5</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>尊享e生·重疾险</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人重大疾病保险（互联网2025版B款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932612025070428073
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">6</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>尊享e生·百万医疗保险2026版</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人住院医疗费用补偿保险（互联网2024版A款）</span>
								<span>附加住院津贴医疗保险（互联网2024版A款）</span>
								<span>个人重大疾病保险（互联网2022版A款）</span>
								<span>附加重大疾病扩展特需医疗保险（互联网2022版A款）</span>
								<span>个人门急诊医疗保险（互联网2022版D款）</span>
								<span>附加免赔额豁免保险（互联网2022版C款）</span>
								<span>附加个人互联网药品费用医疗保险（互联网2024版A款）</span>
								<span>个人医疗保险（互联网2025版）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932512024091300633<br/>
							C00017932522024120302643,(众安在线)(备-医疗保险)【2025】(附) 039号<br/>
							C00017932612021111900413,(众安在线)(备-疾病保险)【2021】(主) 100号<br/>
							C00017932522021112600433,(众安在线)(备-医疗保险)【2021】(附) 163号<br/>
							C00017932512022011303351,(众安在线)(备-医疗保险)【2021】(主) 188号<br/>
							C00017932522022111638511,(众安在线)(备-医疗保险)【2022】(附) 016号<br/>
							C00017932522024060603013,(众安在线)(备-医疗保险)【2025】(附) 032号<br/>
							C00017932512025120573893
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">7</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>尊享e生·中高端医疗保险2025版</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人医疗保险（互联网2025版B款）</span>
								<span>附加保险事故限制特约保险（互联网2022版）</span>
								<span>个人重大疾病保险条款（互联网2022版A款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932512025120573903<br/>
							C00017931922022062915531,(众安在线)(备-其他)【2023】(附) 093号<br/>
							C00017932612021111900413(众安在线)(备-疾病保险)【2021】(主) 100号<br/>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">8</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>尊享e生·中高端医疗保险PLUS（2025版）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人医疗保险（互联网2025版B款）</span>
								<span>个人重大疾病保险条款（互联网2022版A款）</span>
								<span>附加免赔额豁免保险条款（互联网2022版C款）</span>
								<span>附加保险事故限制特约保险（互联网2022版）</span>
								<span>附加全球紧急医疗费用保险条款（互联网2025版A款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932512025120573903<br/>
							C00017932612021111900413(众安在线)(备-疾病保险)【2021】(主) 100号<br/>
							C00017932522022111638511,(众安在线)(备-医疗保险)【2022】(附) 016号<br/>
							C00017931922022062915531,(众安在线)(备-其他)【2023】(附) 093号<br/>
							C00017932522025121595603
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">9</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>众民保·中高端医疗险2026</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>个人医疗保险（互联网2026版A款）</span>
								<span>附加保费调整条款（互联网2022版A款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932512026012952923<br/>
							C00017931922022033039893,(众安在线)(备-其他)【2023】(附) 039号
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">10</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>众民保·百万医疗险2025</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>附加免赔额豁免保险（互联网2022版C款）</span>
								<span>附加个人在线问诊药品费用医疗保险（互联网2025版A款）</span>
								<span>附加保费调整条款（互联网2022版A款）</span>
								<span>附加重大疾病救护车费用与异地转诊公共交通费用及住宿费用补偿保险（互联网平台版）</span>
								<span>个人住院医疗保险（互联网2025版）</span>
								<span>附加短期费率扩展条款（互联网）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017932522022111638511,(众安在线)(备-医疗保险)【2022】(附) 016号<br/>
							C00017932522025062426303<br/>
							C00017931922022033039893,(众安在线)(备-其他)【2023】(附) 039号<br/>
							C00017932522025120877363<br/>
							C00017932512025120573923<br/>
							C00017931922023052500753,(众安在线)(备-其他)【2024】(附) 129号
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->
						
						<tr class="el-table__row">
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_142 is-center"
                          >
                            <div class="cell">11</div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_148 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>尊享宝贝·少儿高端医疗险2026版</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_149 is-center"
                          >
                            <div class="cell">
                              <div style="display: inline-block">
                                <span>附加保费调整条款（互联网2022版A款）</span>
								<span>少儿医疗保险（互联网2026版A款）</span>
								<span>附加未成年人先天性疾病住院医疗保险（互联网2025版A款）</span>
								<span>个人齿科医疗保险（互联网2024版A款）</span>
								<span>少儿医疗保险（互联网2026版B款）</span>
                              </div>
                            </div>
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_150 is-center"
                          >
                            C00017931922022033039893,(众安在线)(备-其他)【2023】(附) 039号<br/>
							C00017932512026051122733<br/>
							C00017932522025050720353,(众安在线)(备-医疗保险)【2025】(附) 115号<br/>
							C00017932512024062002973,(众安在线)(备-医疗保险)【2025】(主) 021号<br/>
							C00017932512026051122723
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_151 is-center"
                          >
                            众安在线财产保险股份有限公司
                          </td>
                          <td
                            rowspan="1"
                            colspan="1"
                            class="el-table_38_column_152 is-center"
                          >
                            2019年9月至长期
                          </td>
                        </tr>
                        <!--    ---  -->


                      </tbody>
                </table>

                <!----><!---->
              </div>
              <!----><!----><!----><!---->
              <div
                class="el-table__column-resize-proxy"
                style="display: none"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!--内容结束-->
    </div>
  </div>
</template>

<script>
export default {
  name: "InternetProductInfo",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/internetProductInfo.vue